import { inferMarketFromSymbol, normalizeSymbolInput, type Market } from '@invest-copilot/shared';
import { fetchJSON } from './api-client';

export interface ResolvedSymbol {
  symbol: string;
  name?: string;
  market: Market;
}

interface SymbolNameResponse {
  symbol: string;
  name: string | null;
  market?: 'TW' | 'US';
}

/**
 * 把使用者輸入解析成「正確後綴的 symbol + 市場 + 名稱」。
 * 台股 .TW/.TWO 由後端官方上市櫃表判斷（前端 normalizeSymbolInput 一律補 .TW，碰不到上櫃表）。
 * 後端不可用時退回純前端推斷（market 由後綴猜）。
 */
export async function resolveSymbolInput(input: string): Promise<ResolvedSymbol | undefined> {
  const normalized = normalizeSymbolInput(input);
  if (!normalized) return undefined;
  try {
    const res = await fetchJSON<SymbolNameResponse>(`/api/symbol-name/${encodeURIComponent(normalized)}`);
    const symbol = res.symbol || normalized;
    return {
      symbol,
      name: res.name ?? undefined,
      market: res.market ?? inferMarketFromSymbol(symbol),
    };
  } catch {
    return { symbol: normalized, market: inferMarketFromSymbol(normalized) };
  }
}
